<template>

<div class="additional-email-addresses-field">
	<h4>{{ heading || 'Additional Email Addresses' }}</h4>

	<ul class="list-group mb-2">
		<li v-for="(email, index) in value || []" class="list-group-item list-group-item-action" v-on:click="removeEmailAddress(index)" style="cursor: pointer">
			<div class="d-flex justify-content-between align-items-center">
				<span>{{ email }}</span>
				<i class="fa fa-trash icon-button"></i>
			</div>
		</li>
	</ul>

	<div class="d-flex">
		<field
			label="Add an email"
			style="flex-grow: 1"
			col-class="col-md-4"
			:params="{type:'email'}"
			v-model="emailInput">
		</field>
		<div>
			<button type="button" class="btn btn-success btn-attached" v-on:click="addEmailAddress">
				Add
			</button>
		</div>
	</div>
</div>

</template>

<script type="text/javascript">
import Field from "@/components/Field"

export default {
	name: "AdditionalEmailAddressesField",
	components: {
		Field
	},
	props: ["value", "heading"],
	data() {
		return {
			emailInput: ""
		}
	},
	methods: {
		addEmailAddress() {
			let addr = (this.emailInput || "").trim()
			if (!addr)
				return
			this.$emit("input", (this.value || []).concat([addr]))
			this.emailInput = ""
		},
		removeEmailAddress(index) {
			let next = (this.value || []).slice()
			next.splice(index, 1)
			this.$emit("input", next)
		}
	}
}
</script>
